import { Directive, TemplateRef } from '@angular/core';

/**
 * Projects a full-width group-header row template into {@link TrTableComponent}.
 * Rendered above the first row of each group when the host supplies a `groupBy`
 * function (e.g. reservations grouped by day).
 *
 * Usage: `<ng-template trGroupHeader let-row let-key="groupKey" let-i="index"> … </ng-template>`.
 * The template's context is `{ $implicit: row, groupKey, index }`.
 */
@Directive({
  selector: '[trGroupHeader]',
  standalone: false,
})
export class TrGroupHeaderDirective {
  constructor(public readonly template: TemplateRef<unknown>) {}
}
